import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const DialogOrarioOccupato = ({ open, onClose }) => (
    <Dialog open={open} disableEscapeKeyDown>
        <DialogTitle>Ops! L'orario scelto è già occupato.</DialogTitle>
        <DialogContent style={{ backgroundColor: '#383838' }}>
            <DialogContentText>
                Ti invitiamo a scegliere un nuovo orario disponibile.
            </DialogContentText>
        </DialogContent>
        <DialogActions style={{ margin: '0 auto' }}>
            <Button onClick={onClose} size="small" variant='contained' color="primary" autoFocus>
                scegli un altro orario
            </Button>
        </DialogActions>
    </Dialog>
);

export default DialogOrarioOccupato;
